<template>
  <div>
    <div style="margin-top: 5px">
      <div style="margin-bottom: -20px; position: relative; z-index: 1">
        <span v-if="activeTabName === 'shiftTab'">
          <el-select
              class="button-left"
              v-model="dataSearch.isActive"
              @change="searchPackageProperties()"
              placeholder="Chọn trạng thái"
          >
            <el-option label="Đang sử dụng" :value="true"></el-option>
            <el-option label="Ngừng sử dụng" :value="false"></el-option>
          </el-select>
            <el-select
                class="button-left"
                v-model="dataSearch.teamType"
                placeholder="Chọn bộ phận"
                clearable
                @change="searchPackageProperties()"
            >
              <el-option
                  v-for="item in listTeamType"
                  :key="item.key"
                  :value="item.value"
                  :label="item.label"
              >
              </el-option>
            </el-select>
           <el-select
               class="button-left"
               v-model="dataSearch.targetType"
               placeholder="Chọn đối tượng"
               clearable
               @change="searchPackageProperties()"
           >
              <el-option
                  v-for="item in listObjectType"
                  :key="item.key"
                  :value="item.value"
                  :label="item.label"
              >
              </el-option>
            </el-select>
          <el-input
              style="width: 300px"
              placeholder="Nhập tên ca"
              clearable
              v-model="dataSearch.name"
              @clear="searchPackageProperties()"
              @keyup.enter.native="searchPackageProperties()"
          >
            <el-button
                slot="append"
                icon="el-icon-search"
                @click="searchPackageProperties()"
            ></el-button>
          </el-input>
        </span>
        <el-input
            v-else-if="activeTabName === 'classShiftTab'"
            style="width: 300px"
            placeholder="Nhập tên lớp"
            clearable
            v-model="className"
            @clear="fetchDataClassSearchPackage('')"
            @change="searchClassPackageByProperties()"
        >
          <el-button
              slot="append"
              icon="el-icon-search"
              @click="searchClassPackageByProperties()"
          ></el-button>
        </el-input>
        <el-input
            v-else-if="activeTabName === 'groupShiftTab'"
            style="width: 300px"
            placeholder="Nhập tên nhóm"
            clearable
            v-model="groupName"
            @clear="fetchDataClassSearchPackage('')"
            @change="searchGroupPackageByProperties()"
        >
          <el-button
              slot="append"
              icon="el-icon-search"
              @click="searchGroupPackageByProperties()"
          ></el-button>
        </el-input>
        <el-input
            v-else-if="activeTabName === 'departmentShiftTab'"
            style="width: 300px"
            placeholder="Nhập tên phòng ban"
            clearable
            v-model="departmentName"
            @clear="fetchDataClassSearchPackage('')"
            @change="searchDepartmentPackageByProperties()"
        >
          <el-button
              slot="append"
              icon="el-icon-search"
              @click="searchDepartmentPackageByProperties()"
          ></el-button>
        </el-input>
      </div>
      <el-tabs type="card" @tab-click="handleClickTab" v-model="activeTabName">
        <!-- thiết lập ca -->
        <el-tab-pane label="Thiết lập ca lớp" name="classShiftTab">
          <el-table
              ref="multipleTable"
              highlight-current-row
              :empty-text="textTable"
              v-loading="loadingData"
              :element-loading-text="$tableLoading"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(255,255,255, 0)"
              :data="responseClassList"
              :cell-style="tableRowStyle"
              :header-cell-style="tableHeaderColor"
              :max-height="$tableMaxHeight"
              border
          >
            <el-table-column
                fixed
                type="index"
                label="STT"
                width="50"
                align="center"
            ></el-table-column>
            <el-table-column
                fixed
                prop="teamName"
                label="Tên lớp"
                min-width="150"
            ></el-table-column>
            <el-table-column
                prop="teamGrade"
                label="Tên khối"
                min-width="150"
            ></el-table-column>
            <el-table-column
                prop="assignedShifts"
                align="center"
                label="Ca áp dụng"
                min-width="150"
            ></el-table-column>
            <el-table-column label="Tác vụ" fixed="right" width="160" align="center">
              <template v-slot:default="scope">
                <el-button size="mini" type="success" @click="addDialogMethod(scope.row, 'CLASS')"
                >Thêm ca
                </el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-row type="flex">
            <el-col :span="22" style=" margin: 15px 0">
              <div class="container_nav_page">
                <el-pagination
                    background
                    layout="prev, pager, next, sizes"
                    @size-change="handleSizeChangeClass"
                    @current-change="handleCurrentPageChangeClass"
                    :current-page.sync="dataSearchClass.page"
                    :page-sizes="listSizePage"
                    :total="totalClass">
                </el-pagination>
              </div>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="Thiết lập ca nhóm" name="groupShiftTab">
          <el-table
              ref="multipleTable"
              highlight-current-row
              :empty-text="textTable"
              v-loading="loadingData"
              :element-loading-text="$tableLoading"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(255,255,255, 0)"
              :data="responseGroupList"
              :cell-style="tableRowStyle"
              :header-cell-style="tableHeaderColor"
              :max-height="$tableMaxHeight"
              border
          >
            <el-table-column
                fixed
                type="index"
                label="STT"
                width="50"
                align="center"
            ></el-table-column>
            <el-table-column
                fixed
                prop="teamName"
                label="Tên nhóm"
                min-width="150"
            ></el-table-column>
            <el-table-column
                prop="assignedShifts"
                align="center"
                label="Ca áp dụng"
                min-width="150"
            ></el-table-column>
            <el-table-column label="Tác vụ" fixed="right" width="160" align="center">
              <template v-slot:default="scope">
                <el-button size="mini" type="success" @click="addDialogMethod(scope.row, 'GROUP')"
                >Thêm ca
                </el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-row type="flex">
            <el-col :span="22" style=" margin: 15px 0">
              <div class="container_nav_page">
                <el-pagination
                    background
                    layout="prev, pager, next, sizes"
                    @size-change="handleSizeChangeGroup"
                    @current-change="handleCurrentPageChangeGroup"
                    :current-page.sync="dataSearchGroup.page"
                    :page-sizes="listSizePage"
                    :total="totalGroup">
                </el-pagination>
              </div>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="Thiết lập ca phòng ban" name="departmentShiftTab">
          <el-table
              ref="multipleTable"
              highlight-current-row
              :empty-text="textTable"
              v-loading="loadingData"
              :element-loading-text="$tableLoading"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(255,255,255, 0)"
              :data="responseDepartmentList"
              :cell-style="tableRowStyle"
              :header-cell-style="tableHeaderColor"
              :max-height="$tableMaxHeight"
              border
          >
            <el-table-column
                fixed
                type="index"
                label="STT"
                width="50"
                align="center"
            ></el-table-column>
            <el-table-column
                fixed
                prop="teamName"
                label="Tên phòng ban"
                min-width="150"
            ></el-table-column>
            <el-table-column
                prop="assignedShifts"
                align="center"
                label="Ca áp dụng"
                min-width="150"
            ></el-table-column>
            <el-table-column label="Tác vụ" fixed="right" width="160" align="center">
              <template v-slot:default="scope">
                <el-button size="mini" type="success" @click="addDialogMethod(scope.row, 'DEPARTMENT')"
                >Thêm ca
                </el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-row type="flex">
            <el-col :span="22" style=" margin: 15px 0">
              <div class="container_nav_page">
                <el-pagination
                    background
                    layout="prev, pager, next, sizes"
                    @size-change="handleSizeChangeDepartment"
                    @current-change="handleCurrentPageChangeDepartment"
                    :current-page.sync="dataSearchDepartment.page"
                    :page-sizes="listSizePage"
                    :total="totalDepartment">
                </el-pagination>
              </div>
            </el-col>
          </el-row>
        </el-tab-pane>
        <!-- quản lý khoản -->
        <el-tab-pane label="Danh sách ca" name="shiftTab">
          <el-table
              ref="multipleTable"
              :empty-text="textTable"
              v-loading="loadingData"
              :element-loading-text="$tableLoading"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(255,255,255, 0)"
              highlight-current-row
              :data="responseShiftList"
              :cell-style="tableRowStyle"
              :header-cell-style="tableHeaderColor"
              :max-height="$tableMaxHeight"
              @selection-change="handleSelectionChange"
              border
          >
            <el-table-column
                fixed
                type="index"
                label="STT"
                width="50"
                align="center"
            ></el-table-column>
            <el-table-column
                fixed
                prop="name"
                label="Tên ca"
                min-width="190"
            ></el-table-column>
            <el-table-column
                prop="description"
                label="Mô tả"
                min-width="180"
            ></el-table-column>
            <el-table-column
                prop="startTime"
                align="center"
                label="Thời gian bắt đầu"
                min-width="150"
            ></el-table-column>
            <el-table-column
                prop="endTime"
                align="center"
                label="Thời gian kết thúc"
                min-width="150"
            ></el-table-column>
            <el-table-column
                prop="autoAttendanceEnable"
                align="center"
                label="Bộ phận áp dụng"
                width="100"
            >
              <template v-slot:default="scope">
                <span v-if="scope.row.teamType === 'CLASS'">Lớp</span>
                <span v-if="scope.row.teamType === 'GROUP'">Nhóm</span>
                <span v-if="scope.row.teamType === 'DEPARTMENT'">Phòng ban</span>
              </template>
            </el-table-column>
            <el-table-column
                prop="autoAttendanceEnable"
                align="center"
                label="Đối tượng áp dụng"
                width="100"
            >
              <template v-slot:default="scope">
                <span v-if="scope.row.targetType === 'STUDENT'">Học sinh</span>
                <span v-if="scope.row.targetType === 'TEACHER'">Nhân sự
                </span>
              </template>
            </el-table-column>
            <el-table-column
                prop="autoAttendanceEnable"
                align="center"
                label="Điểm danh tự động AI"
                width="100"
            >
              <template v-slot:default="scope">
                <span v-if="scope.row.autoAttendanceEnable">Có</span>
                <span v-else>Không</span>
              </template>
            </el-table-column>
            <el-table-column
                prop="applyAttendanceEat"
                align="center"
                label="Áp dụng điểm danh ăn"
                width="150"
            >
              <template v-slot:default="scope">
                <span v-if="scope.row.applyAttendanceEat">Có</span>
                <span v-else>Không</span>
              </template>
            </el-table-column>
            <el-table-column label="Tác vụ" fixed="right" width="220" align="center">
              <template v-slot:default="scope">
                <el-button
                    size="mini"
                    type="success"
                    @click="handleOpenUpdateShiftMasterDialog(scope.row)"
                >{{ $t("button.update") }}
                </el-button
                >
                <el-button
                    :disabled="scope.row.isActive"
                    size="mini"
                    type="danger"
                    @click="deletePackageMethod(scope.row)"
                >{{ $t("button.delete") }}
                </el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-row type="flex">
            <el-col :span="22" style=" margin: 15px 0">
              <div class="container_nav_page">
                <el-pagination
                    background
                    layout="prev, pager, next, sizes"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentPageChange"
                    :current-page.sync="dataSearch.page"
                    :page-sizes="listSizePage"
                    :total="total">
                </el-pagination>
              </div>
            </el-col>
            <el-col :span="2">
              <div style="float: right; margin: 15px 0">
                <el-dropdown @command="handleCommandAction">
                  <el-button class="button-bottom" type="success">
                    Tác vụ
                    <i class="el-icon-caret-bottom"/>
                  </el-button>
                  <el-dropdown-menu class="el-dropdown-menu-container">
                    <el-dropdown-item command="addShift">Tạo ca</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </div>
    <AddShiftMasterDialog
        :isOpenAddShiftMasterDialog="isOpenAddShiftMasterDialog"
        @dialog-close="dialogCloseAddShiftMasterDialog()"
    />
    <UpdateShiftMasterDialog
        :isOpenUpdateShiftMasterDialog="isOpenUpdateShiftMasterDialog"
        :dataUpdate="dataUpdate"
        @dialog-close="dialogCloseUpdateShiftMasterDialog()"
    />
    <AddShiftManagementDialog
        :dialogVisible="showAddDialog"
        @dialog-close="dialogCloseAddMethod()"
        ref="AddShiftManagementDialog"
    />
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import NotifyMessage from "@/commonFuncion/NotifyMessage";
import AddShiftMasterDialog from "@/views/attendance-v2/dialog/AddShiftMasterDialog.vue";
import UpdateShiftMasterDialog from "@/views/attendance-v2/dialog/UpdateShiftMasterDialog.vue";
import shiftMaster from "@/services/ShiftMaster";
import AddShiftManagementDialog from "@/views/attendance-v2/dialog/AddShiftManagementDialog.vue";

export default {
  components: {
    AddShiftManagementDialog,
    UpdateShiftMasterDialog,
    AddShiftMasterDialog,
  },
  data() {
    return {
      textTable: "",
      loadingData: false,
      activeTabName: "classShiftTab",
      responseShiftList: [],
      multipleSelection: [],
      showCreateDialog: false,
      showUpdateDialog: false,
      showAddDialog: false,
      dataUpdate: {},
      dataSearch: {
        name: "",
        isActive: true,
        targetType: "",
        teamType: "",
        limit: 25,
        page: 1,
      },
      dataSearchClass: {
        name: "",
        limit: 25,
        page: 1,
      },
      dataSearchGroup: {
        name: "",
        limit: 25,
        page: 1,
      },
      dataSearchDepartment: {
        name: "",
        limit: 25,
        page: 1,
      },
      totalClass: 0,
      totalGroup: 0,
      totalDepartment: 0,
      listSizePage: [25, 50, 100, 150, 200],
      total: 0,
      className: "",
      groupName: "",
      responseClassList: [],
      responseGroupList: [],
      responseDepartmentList: [],
      type: "",
      isOpenAddShiftMasterDialog: false,
      isOpenUpdateShiftMasterDialog: false,
      listObjectType: [
        {key: 1, value: "STUDENT", label: "Học sinh"},
        {key: 2, value: "TEACHER", label: "Nhân sự"},
      ],
      listTeamType: [
        {key: 1, value: "CLASS", label: "Lớp"},
        {key: 2, value: "GROUP", label: "Nhóm"},
        {key: 3, value: "DEPARTMENT", label: "Phòng ban"},
      ],
      idDepartment: "",
      departmentName: "",
    };
  },
  computed: {
    ...mapGetters('departmentStore', ['departmentList']),
  },
  created() {
    this.$store.dispatch('classStore/fetchDataClassSearchPackage', this.className)
    this.$store.dispatch('departmentStore/fetchDataDepartmentList')

  },
  methods: {
    ...mapActions('classStore', ['fetchDataClassSearchPackage']),
    ...mapMutations('classStore', ['SET_ClassSearchPackage']),
    tableHeaderColor() {
      return "background-color: #78a5e7;color: #fff;font-weight: bold;";
    },
    tableRowStyle({row}) {
      if (row.category === "out") {
        return "color: #409EFF";
      }
    },
    handleClickTab(tab) {
      let tabNameClick = tab.name;
      if (tabNameClick === "classShiftTab") {
        this.searchClassPackageByProperties();
      } else if (tabNameClick === "shiftTab") {
        this.searchPackageProperties();
      } else if (tabNameClick === "groupShiftTab") {
        this.searchGroupPackageByProperties();
      } else if (tabNameClick === "departmentShiftTab") {
        this.searchDepartmentPackageByProperties();
      }

    },

    dialogCloseUpdateMethod() {
      this.showUpdateDialog = false;
      this.searchPackageProperties();
    },
    dialogCloseAddMethod() {
      this.showAddDialog = false;
      if (this.type === 'CLASS') {
        this.searchClassPackageByProperties();
      } else if (this.type === 'GROUP') {
        this.searchGroupPackageByProperties();
      } else if (this.type === 'DEPARTMENT') {
        this.searchDepartmentPackageByProperties();
      }
    },

    addDialogMethod(row, type) {
      this.showAddDialog = true;
      this.type = type;
      this.$refs.AddShiftManagementDialog.getAddDataInitial(row, type);
    },
    //select rows
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    handleCommandAction(command) {
      if (command === "addShift") {
        this.handleOpenAddShiftMasterDialog();
      }
    },
    /**
     * thêm ca
     */
    handleOpenAddShiftMasterDialog() {
      this.isOpenAddShiftMasterDialog = true;
    },
    dialogCloseAddShiftMasterDialog() {
      this.isOpenAddShiftMasterDialog = false;
      this.searchPackageProperties();
    },
    handleOpenUpdateShiftMasterDialog(row) {
      this.dataUpdate = row;
      this.isOpenUpdateShiftMasterDialog = true;
    },
    dialogCloseUpdateShiftMasterDialog() {
      this.isOpenUpdateShiftMasterDialog = false;
      this.searchPackageProperties();
    },
    /**
     * xóa ca
     */
    deletePackageMethod(row) {
      this.$confirm("Bạn có chắc chắn muốn xóa ca này?", "Thông báo!", {
        distinguishCancelAndClose: true,
        closeOnClickModal: false,
        confirmButtonText: "Có",
        cancelButtonText: "Không",
      }).then(() => {
        shiftMaster.deleteShift(row.id)
            .then(() => {
              NotifyMessage.leftCornerNotificationSuccess("Xóa thành công!")
              this.searchPackageProperties();
            })
            .catch((err) => {
              console.log(err)
              NotifyMessage.leftCornerNotificationError("Xóa thất bại");
            });
      });
    },
    searchPackageProperties() {
      this.loadingData = true;
      shiftMaster.getAllShifts(
          this.dataSearch.isActive,
          this.dataSearch.teamType,
          this.dataSearch.targetType,
          this.dataSearch.name,
          this.dataSearch.page,
          this.dataSearch.limit
      )
          .then((resp) => {
            this.responseShiftList = resp.data.data.content;
            this.total = resp.data.data.totalElements
          })
          .catch((err) => {
            this.$message({
              message: err.response.data.message,
              type: "error",
            });
            this.responseShiftList = [];
          })
          .finally(() => {
            if (this.responseShiftList.length === 0) {
              this.textTable = this.$tableEmpty;
            }
            this.loadingData = false;
          });
    },
    /**
     * Phân trang
     */
    handleSizeChange(value) {
      this.dataSearch.limit = value;
      this.searchPackageProperties();
    },
    handleCurrentPageChange(value) {
      this.dataSearch.page = value;
      this.searchPackageProperties();
    },
    handleSizeChangeClass(value) {
      this.dataSearchClass.limit = value;
      this.searchClassPackageByProperties();
    },
    handleCurrentPageChangeClass(value) {
      this.dataSearchClass.page = value;
      this.searchClassPackageByProperties();
    },
    handleSizeChangeGroup(value) {
      this.dataSearchGroup.limit = value;
      this.searchClassPackageByProperties();
    },
    handleCurrentPageChangeGroup(value) {
      this.dataSearchGroup.page = value;
      this.searchClassPackageByProperties();
    },
    handleSizeChangeDepartment(value) {
      this.dataSearchDepartment.limit = value;
      this.searchClassPackageByProperties();
    },
    handleCurrentPageChangeDepartment(value) {
      this.dataSearchDepartment.page = value;
      this.searchClassPackageByProperties();
    },


    searchClassPackageByProperties() {
      shiftMaster.getShiftAssignments(this.className, "CLASS", this.dataSearchClass.page, this.dataSearchClass.limit)
          .then(response => {
            this.responseClassList = response.data.data.content;
            this.totalClass = response.data.data.totalElements
          }).catch(error => {
        console.log(error);
      });

    },

    searchGroupPackageByProperties() {
      shiftMaster.getShiftAssignments(this.groupName, "GROUP", this.dataSearchGroup.page, this.dataSearchGroup.limit)
          .then(response => {
            this.responseGroupList = response.data.data.content;
            this.totalGroup = response.data.data.totalElements
          }).catch(error => {
        console.log(error);
      });
    },

    searchDepartmentPackageByProperties() {
      shiftMaster.getShiftAssignments(this.departmentName, "DEPARTMENT", this.dataSearchDepartment.page, this.dataSearchDepartment.limit)
          .then(response => {
            this.responseDepartmentList = response.data.data.content;
            this.totalDepartment = response.data.data.totalElements
          }).catch(error => {
        console.log(error);
      });
    },
  },

  beforeMount() {
    this.searchClassPackageByProperties();
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-tabs__nav {
  background: #a0a19ce0;
}

/deep/ .el-tabs__item {
  color: white;
}

/deep/ .el-tabs__item.is-active {
  color: white;
  background: #78a5e7;
}

/deep/ .el-form-item__label {
  font-family: Arial, Helvetica, sans-serif;
}

/deep/ .el-tabs__nav-scroll {
  float: right;
}

/deep/ .el-tabs__header {
  margin-bottom: 0;
}

/deep/ .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  border-bottom-color: #78a5e7;
}

/deep/ .el-tabs--card > .el-tabs__header {
  border-bottom: none;
}


/deep/ .el-checkbox__inner {
  border: 1px solid gray;
}

.input-common {
  margin-right: 5px;
}

.button-bottom {
  border-radius: 0;
  margin-left: 3px;
}

.button-click {
  float: right;
  margin: 20px 0 40px 0;
}

.el-dropdown-menu {
  position: absolute;
  top: 0;
  left: 0;
  padding: 0 0;
  margin: 3px 0;
  background-color: #5fb44a;
  border: 1px solid #ebeef5;
  border-radius: 0;
  box-shadow: 0 2px 12px 0 #0000001a;
}

.el-dropdown-menu li {
  color: white;
  border-top: 1px solid white;
  font-family: Arial, Helvetica, sans-serif;
}

.over-table {
  width: 97%;
  margin: 0 auto;
}

.table-data {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #ebeef5;
}

.wrapper-table {
  height: 600px;
  overflow-y: scroll;
  border-bottom: 1px solid #ebeef5;
}

thead {
  background: #78a5e7;
  color: white;
  font-weight: bold;
  // display: block;
  // width: 90%;
}

tbody {
  color: #606266;
  font-size: 14px;
  overflow: auto;
  font-family: Arial, Helvetica, sans-serif;
}

// td {
//   padding: 12px;
// }
.table-index {
  width: 10px;
  text-align: center;
}

.table-item-name {
  width: 200px;
  text-align: center;
}

.table-action {
  width: 200px;
  text-align: center;
}

.color-text-reply {
  color: #4177e2;
}

.input-data {
  width: 60%;
}

.disable-row {
  background: #e4e7ed;
}

.button-left {
  margin-right: 5px;
  width: 150px;
}

.container_nav_page {
  display: flex;
  justify-content: center;
}
</style>
